// Only the CRM app itself is skipped — upsales.com (the marketing site) is a
// normal company website and stays matchable.
const SKIPPED_DOMAINS = [
	'power.upsales.com',
	'google.com',
	'google.se',
	'bing.com',
	'duckduckgo.com',
	'office.com',
	'live.com',
	'outlook.com'
];

// Returns the normalized domain when the page plausibly belongs to a company
// website, or null when matching would be pointless (internal pages, search
// engines, webmail, Upsales itself).
export const matchablePageDomain = (url: string): string | null => {
	if (!url || !/^https?:\/\//i.test(url)) return null;
	const domain = url
		.replace(/^https?:\/\//i, '')
		.replace(/^www\./i, '')
		.replace(/[/?#].*$/, '')
		.replace(/:\d+$/, '')
		.toLowerCase();
	if (!domain.includes('.')) return null;
	if (domain === 'localhost' || /^\d{1,3}(\.\d{1,3}){3}$/.test(domain)) return null;
	if (SKIPPED_DOMAINS.some(skipped => domain === skipped || domain.endsWith('.' + skipped))) return null;
	return domain;
};
